export type EnumLiteralsOf<T extends object> = T[keyof T];

export type AttoDeskStores = EnumLiteralsOf<typeof AttoDeskStores>;

export const AttoDeskStores = Object.freeze({
  DEFAULT: "DEFAULT" as const,
  PRODUCT: "PRODUCT" as const,
  CATEGORY: "CATEGORY" as const,
  // SALEDETAILS: 'SALEDETAILS' as const,
});

export const Level = Object.freeze({
  1: "1" as const,
  2: "2" as const,
  3: "3" as const,
  4: "4" as const,
});

export const Grade = Object.freeze({
  A: "A" as const,
  B: "B" as const,
  C: "c" as const,
  D: "D" as const,
});

export const PaymentMethod = Object.freeze({
  PAD: "PAD" as const,
  DSSAB: "DSSAB" as const,
  Chq: "Chq" as const,
  EFT: "EFT" as const,
  PGT: "PGT" as const,
  Cash: "Cash" as const,
  ODSP: "ODSP" as const,
  LMR: "LMR" as const,
  BISNO: "BISNO" as const,
});

export const PaymentMethod2 = Object.freeze({
  DirectDeposit: "Direct Deposit" as const,
  Cheque: "Cheque" as const,
  Both: "Both" as const,
});

export const Gender = Object.freeze({
  Male: "Male" as const,
  Female: "Female" as const,
  Other: "Other" as const,

});

export const Relationship = Object.freeze({
  Son: "Son" as const,
  Daughter: "Daughter" as const,
  Grandson: "Grandson" as const,
  Granddaughter: "Granddaughter" as const,
  Spouse: "Spouse" as const,
  Sibling: "Sibling" as const,
  Friend: "Friend" as const,
  Other: "Other" as const,
});

export const PaymentStatus = Object.freeze({
  Pending: "pending" as const,
  Paid: "paid" as const,
});

export const TableColumnTypeLevel = Object.freeze({
  string: "string" as const,
  integer: "integer" as const,
  boolean: "boolean" as const,
  // date: 3 as const,
});

export const TableColumnFieldLevel = Object.freeze({
  TextField: "TextField" as const,
  Switch: "Switch" as const,
  Selector: "Selector" as const,
  // MultipleSelector: "MultipleSelector" as const,
  // date: 3 as const,
});

export const ItemServiceChargeType = Object.freeze({
  None: 0 as const,
  Pay: 1 as const,
});

export const RooleType = Object.freeze({
  FOOD: 1 as const,
  Beverages: 2 as const,
  Alcohol: 3 as const,
  Desserts: 4 as const,
});

// export const SizeOfLevelType = Object.freeze({
//   Bottle: 1 as const,
//   Combo: 2 as const,
//   Each: 3 as const,
//   gal: 4 as const,
//   gm: 5 as const,
//   kg: 6 as const,
//   Large: 7 as const,
//   li: 8 as const,
//   lb: 9 as const,
//   Medium: 10 as const,
//   oz: 11 as const,
//   small: 12 as const,
// });

export const SizeOfLevelType = Object.freeze({
  Bottle: 1 as const,
  Each: 2 as const,
  kg: 3 as const,
  Large: 4 as const,
  li: 5 as const,
  Medium: 6 as const,
  small: 7 as const,
  case : 8 as const,
});

export const PunchStatus = Object.freeze({
  punch_in: "punch_in" as const,
  punch_out: "punch_out" as const,
});

export const Privileges = Object.freeze({
  DashboardView: "Dashboard_View" as const,
  SettingView: "Setting_View" as const,
  UserView: "User_View" as const,
  CompanyView: "Company_View" as const,
  DepartmentView: "Department_View" as const,
  UserRoleView: "User_Role_View" as const,
  PrivilegeView: "Privilege_View" as const,
  ThemeView: "Theme_View" as const,
  EmailView: "Email_View" as const,
  // Communication Campaigns (Phase 2 Pass A). Send/Delete deliberately
  // separate from View so a marketing-focused admin can browse
  // history without gaining permission to dispatch.
  CampaignView:   "Campaign_View" as const,
  CampaignCreate: "Campaign_Create" as const,
  CampaignSend:   "Campaign_Send" as const,
  CampaignDelete: "Campaign_Delete" as const,
  CampaignSendTransactional: "Campaign_SendTransactional" as const,
  CommunicationHistoryView:  "CommunicationHistory_View" as const,
  DirectCommunicationView:            "DirectCommunication_View" as const,
  DirectCommunicationSend:            "DirectCommunication_Send" as const,
  DirectCommunicationSendTransactional: "DirectCommunication_SendTransactional" as const,
  PunchDetailsView: "PunchDetails_View" as const,
  ScheduleView: "Schedule_View" as const,
  PayrollView: "Payroll_View" as const,
  StaffView: "Staff_View" as const,
  PositionView: "Position_View" as const,
  ScheduleEdit: "Schedule_Edit" as const,
  GeneratePayroll: "Generate_Payroll" as const,
  StudentView: "Student_View" as const,
  ClassesView: "Classes_View" as const,
  ClassesEdit: "Classes_Edit" as const,
  ClassScheduleView: "ClassSchedule_View" as const,
  ClassScheduleEdit: "ClassSchedule_Edit" as const,
  ClassScheduleDelete: "ClassSchedule_Delete" as const,
  AttendanceView: "Attendance_View" as const,
  AttendanceRecordCreate: "AttendanceRecord_Create" as const,
  AttendanceRecordEdit: "AttendanceRecord_Edit" as const,
  CourseView: "Course_View" as const,
  AssignmentView: "Assignment_View" as const,
  PaymentView: "Payment_View" as const,
  InvoiceView: "Invoice_View" as const,
  MessageView: "Message_View" as const,
  NotificationView: "Notification_View" as const,
  PermissionView: "Permission_View" as const,
  ActivityLogView: "ActivityLog_View" as const,
  StaffAvailabilityView: "StaffAvailability_View" as const,
  StudentNoteView: "StudentNote_View" as const,
  ReportView: "Report_View" as const,
  ParentPortalView: "Parent_Portal_View" as const,
  ParentView: "Parent_View" as const,
  ParentCreate: "Parent_Create" as const,
  ParentEdit: "Parent_Edit" as const,
  ParentDelete: "Parent_Delete" as const,
  ProgramView: "Program_View" as const,
  ProgramLibraryView: "Program_Library_View" as const,
  WorkflowView: "Workflow_View" as const,
  MasteryView: "Mastery_View" as const,
  MasteryApprove: "Mastery_Approve" as const,
  PromptTemplateView: "PromptTemplate_View" as const,
  SessionDataView: "SessionData_View" as const,
  SubjectView: "Subject_View" as const,
  SubjectCreate: "Subject_Create" as const,
  ClassBackupImportView: "ClassBackupImport_View" as const,
  ClassBackupImportExecute: "ClassBackupImport_Execute" as const,
  AcademicReportStudentSubjects: "AcademicReport_StudentSubjects" as const,
  AcademicReportStaffCapacity:   "AcademicReport_StaffCapacity" as const,
  AcademicReportStudentClasses:  "AcademicReport_StudentClasses" as const,
  AcademicReportStaffTimetable:   "AcademicReport_StaffTimetable" as const,
  AcademicReportStudentTimetable: "AcademicReport_StudentTimetable" as const,
  HelpArticleView:    "HelpArticle_View" as const,
  HelpArticleCreate:  "HelpArticle_Create" as const,
  HelpArticleEdit:    "HelpArticle_Edit" as const,
  HelpArticleDelete:  "HelpArticle_Delete" as const,
  HelpArticlePublish: "HelpArticle_Publish" as const,
});

export const UserRole = Object.freeze({
  Admin: 2 as const,
  User: 3 as const,
});

export const RoomType = Object.freeze({
  S: "S" as const,
  "1B": "1B" as const,
  "1B+": "1B+" as const,
  "2B": "2B" as const,
  "2B+": "2B+" as const,
});

export const OrderListStatus = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const OrderListStatus2 = Object.freeze({
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "UpdatedPrice": "UpdatedPrice" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const OrderListStatusList = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "UpdatedPrice": "UpdatedPrice" as const,
  // "ManagerConfirmed": "ManagerConfirmed" as const,
  "Processed": "Processed" as const,
  "Completed": "Completed" as const,
  "Rejected": "Rejected" as const,
 
});

export const fixedPriceConfiem = Object.freeze({
  "Processed": "Processed" as const,
  "Rejected": "Rejected" as const,
});

export const beforePriceConfiem = Object.freeze({
  "SentToManager": "SentToManager" as const,
  "ManagerApproved": "ManagerApproved" as const,
  "Rejected": "Rejected" as const,
});

export const editPriceOrderListStatus = Object.freeze({
  "OrderListCreated": "OrderListCreated" as const,
  "SentToManager": "SentToManager" as const,
  "Rejected": "Rejected" as const,
});

export const emailNotification = Object.freeze({
  "Admin": "Admin" as const,
  "Punch Notification": "Punch Notification" as const,
  "Payroll Notification": "Payroll Notification" as const,
});

export const punchSliderItems = Object.freeze({
  "image": "image" as const,
  "video": "video" as const,
});

export const widthofReactQuill = Object.freeze({
  "200px": "200px" as const,
  "300px": "300px" as const,
  "400px": "400px" as const,
});

export const requestStatus = Object.freeze({
  "Accepted": "Accepted" as const,
  "Cancel": "Cancel" as const,
});

export const RelationshipType = Object.freeze({
  Parent: "Parent" as const,
  Guardian: "Guardian" as const,
  Other: "Other" as const,
});

export const heardFrom = Object.freeze({
  "Social Media": "Social Media" as const,
  "Website": "Website" as const,
  "Google Search": "Google Search" as const,

  "Groupon": "Groupon" as const,
  "Internet": "Internet" as const,
  "Referral": "Referral" as const,
  "Family": "Family" as const,
  "Sibling": "Sibling" as const,
  "Window": "Window" as const,
  "Woodside": "Woodside" as const,
  "Flyers": "Flyers" as const,
  "Kijiji": "Kijiji" as const,
  "Location": "Location" as const,
  "EastFM Radio": "EastFM Radio" as const,
});

// Student study mode — canonical values. Display labels live in
// Pages/Student/studentDisplay (STUDY_MODE_OPTIONS / studyModeLabelOf).
export const StudyMood = Object.freeze({
  Online: "online" as const,
  InPerson: "in_person" as const,
});

export const EnumValuType = Object.freeze({
  country: "country" as const,
  province: "province" as const,
  city: "city" as const,

});

export const TeachMood = Object.freeze({
  Online: "Online" as const,
  Offline: "Offline" as const,
  Hybrid: "Hybrid" as const,
});

export const ClassType = Object.freeze({
  "Regular": "Regular" as const,
  "Period-Based": "Period-Based" as const,
});

export const WeekDays = Object.freeze({
  "Sunday": "Sunday" as const,
  "Monday": "Monday" as const,
  "Tuesday": "Tuesday" as const,
  "Wednesday": "Wednesday" as const,
  "Thursday": "Thursday" as const,
  "Friday": "Friday" as const,
  "Saturday": "Saturday" as const,
});

export const AttendanceStatus = Object.freeze({
  Present: "present" as const,
  Absent: "absent" as const,
  Late: "late" as const,
  Excused: "excused" as const,
});

export const CourseStatus = Object.freeze({
  Active: "active" as const,
  Archived: "archived" as const,
  Draft: "draft" as const,
});

export const MaterialType = Object.freeze({
  Pdf: "pdf" as const,
  Video: "video" as const,
  Link: "link" as const,
  Document: "document" as const,
  Image: "image" as const,
});

export const AssignmentType = Object.freeze({
  Homework: "homework" as const,
  Quiz: "quiz" as const,
  Project: "project" as const,
  Exam: "exam" as const,
});

export const SubmissionStatus = Object.freeze({
  Submitted: "submitted" as const,
  Graded: "graded" as const,
  Returned: "returned" as const,
  Late: "late" as const,
});

export const InvoiceStatus = Object.freeze({
  Draft: "draft" as const,
  Sent: "sent" as const,
  Paid: "paid" as const,
  Partial: "partial" as const,
  Overdue: "overdue" as const,
  Cancelled: "cancelled" as const,
});

export const PaymentTypeEnum = Object.freeze({
  Full: "full" as const,
  Partial: "partial" as const,
  Refund: "refund" as const,
});

export const PaymentMethodType = Object.freeze({
  CreditCard: "credit_card" as const,
  DebitCard: "debit_card" as const,
  BankAccount: "bank_account" as const,
  Cash: "cash" as const,
  Cheque: "cheque" as const,
  Etransfer: "etransfer" as const,
});

export const CancellationType = Object.freeze({
  Cancelled: "cancelled" as const,
  Makeup: "makeup" as const,
  Rescheduled: "rescheduled" as const,
});

export const ScheduleType = Object.freeze({
  Regular: "regular" as const,
  Makeup: "makeup" as const,
  Extra: "extra" as const,
});

export const ScheduleStatus = Object.freeze({
  Scheduled: "scheduled" as const,
  Completed: "completed" as const,
  Cancelled: "cancelled" as const,
  Rescheduled: "rescheduled" as const,
});

export const NoteType = Object.freeze({
  General: "general" as const,
  Academic: "academic" as const,
  Behavioral: "behavioral" as const,
  Medical: "medical" as const,
});

export const TutoringType = Object.freeze({
  Regular: "Regular" as const,
  Special: "Special" as const,
});

// Hi Rasmus - Program & Target Statuses
export const ProgramStatus = Object.freeze({
  Waiting: "waiting" as const,
  Baseline: "baseline" as const,
  Active: "active" as const,
  Maintenance: "maintenance" as const,
  Hold: "hold" as const,
  Closed: "closed" as const,
  Discontinued: "discontinued" as const,
});

export const MeasurementType = Object.freeze({
  PercentCorrect: "Percent Correct" as const,
  Frequency: "Frequency" as const,
  Duration: "Duration" as const,
  Rate: "Rate" as const,
  Interval: "Interval" as const,
  WholeInterval: "Whole Interval" as const,
  PartialInterval: "Partial Interval" as const,
  MomentaryTimesampling: "Momentary Timesampling" as const,
});

export const SDType = Object.freeze({
  DiscriminativeStimulus: "discriminative_stimulus" as const,
  VerbalPrompt: "verbal_prompt" as const,
  VisualPrompt: "visual_prompt" as const,
  Gestural: "gestural" as const,
});

export const WorkflowPhase = Object.freeze({
  Probe: "Probe" as const,
  Acquisition: "Acquisition" as const,
  Mastered: "Mastered" as const,
});

export const PhaseTransition = Object.freeze({
  Closed: "Closed" as const,
  Mastered: "Mastered" as const,
  Maintenance: "Maintenance" as const,
});
